(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pincode-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pincode-checker')) {
    customElements.define(
      'pincode-checker',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          const form = this.querySelector('form');
          const input = this.querySelector('input');
          const button = this.querySelector('button');
          const result = this.querySelector('.pincode-checker__result');
          if (!form || !input || !button || !result) return;

          input.addEventListener('input', () => {
            input.value = input.value.replace(/\D/g, '').slice(0, 6);
          });

          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            const pin = input.value.replace(/\D/g, '');

            result.classList.remove('is-error');

            if (pin.length !== 6) {
              result.textContent = 'Enter a valid 6-digit pincode';
              result.classList.add('is-error');
              return;
            }

            button.disabled = true;
            result.textContent = 'Checking...';

            try {
              const response = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
              if (!response.ok) throw new Error('Request failed');
              const data = await response.json();
              const row = data && data[0];
              const offices = row && row.PostOffice ? row.PostOffice : [];
              const office = offices.find((item) => item.DeliveryStatus === 'Delivery');

              if (row && row.Status === 'Success' && office) {
                result.textContent = `Delivery available in ${office.District}, ${office.State}. Estimated delivery: 4–7 days.`;
              } else {
                result.textContent = 'This pincode is not serviceable';
                result.classList.add('is-error');
              }
            } catch (error) {
              result.textContent = 'Could not check this pincode. Please try again.';
              result.classList.add('is-error');
            } finally {
              button.disabled = false;
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
